import { ReactComponent as Logo } from "../../assets/landing-banner.svg";
import { ReactComponent as Check } from "../../assets/icons/by-the-numbers-check.svg";
import LandingTabs from "./LandingTabs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function LandingHero() {
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "flex items-center gap-12 lg:gap-24 mb-16",
      children: [/*#__PURE__*/_jsx(ByTheNumbers, {}), /*#__PURE__*/_jsx(Logo, {})]
    }), /*#__PURE__*/_jsx(LandingTabs, {})]
  });
}
const ByTheNumbers = () => {
  // TODO: fetch data (where to get this?)
  const uniqueDonations = "4.6M";
  const raisedFunds = "5,242";
  const fundingDistributed = "$60,000,000+";
  return /*#__PURE__*/_jsxs("div", {
    className: "w-[300px] lg:w-[380px] h-[460px] flex-shrink-0 flex-col justify-between bg-white/50 hidden md:flex rounded-b-3xl px-6 py-8",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "flex items-center gap-4",
      children: [/*#__PURE__*/_jsx(Check, {}), /*#__PURE__*/_jsx("div", {
        className: "font-medium text-xl lg:text-2xl",
        children: "By the numbers\u2026"
      })]
    }), /*#__PURE__*/_jsx(Stat, {
      value: uniqueDonations,
      label: "Unique donations"
    }), /*#__PURE__*/_jsx(Stat, {
      value: raisedFunds,
      label: "Projects raised funds"
    }), /*#__PURE__*/_jsx(Stat, {
      value: fundingDistributed,
      label: "In funding distributed"
    })]
  });
};
const Stat = _ref => {
  let {
    value = "",
    label = ""
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx("div", {
      className: "font-mono text-3xl lg:text-4xl text-green-300 font-medium tracking-tighter mb-1",
      children: value
    }), /*#__PURE__*/_jsx("div", {
      className: "uppercase text-base lg:text-lg tracking-widest font-medium",
      children: label
    })]
  });
};